import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';
import * as errorAction from '../../core/actions/clear-error.action';

@Component({
    selector: 'ssf-expired-page',
    template: `
        <h1>{{i18n + 'TITLE' | translate}}</h1>
        <p>{{i18n + 'MESSAGE' | translate}}</p>
    `,
    styles: [
            `
            :host {
                text-align: center;
            }
        `,
    ],
})

/**
 * Expired access token - BE returned 401.
 */
export class ExpiredComponent {
    public i18n = 'APP.EXPIRED.';

    constructor(private store: Store<AppState>) {
        this.store.dispatch(new errorAction.ClearErrorAction());
    };
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/components/expired/expired.component.ts